import React, { Component } from 'react';
import { Trans, i18nMark, withI18n } from 'lingui-react';

import { Button } from '../../components/Button/index';
import { ModalDashboad } from './components/ModalDashboad/index';

import { getCompanies, getAssessmentsByCompanyId, getIndustries, getCookieCompanyId, setCookieCompanyId } from '../../services/index';
import qs from 'querystringify';
import validate from 'validate.js';


import imageCenter from '../../assets/images/big_logo.svg';
import './dashBoard.css';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasCompleteCompany: false,
      company: null,
      hasReport: false,
      modal: false,
      assessmentId: null,
      releaseVersion: document.getElementById('releaseVersion').innerHTML
    };
  }

  componentDidMount() {
    document.title = this.props.i18n._(i18nMark('Security Selfie'));
    // Determine pre-selected companyId
    const companyIdFromQuery = qs.parse(this.props.location.search).companyId;
    if (companyIdFromQuery) {
      this.setCompanyState(companyIdFromQuery);
    }
    // Load initial data
    const companyId = getCookieCompanyId(this.props.cookies);
    this.loadInitialData(companyId);
    const errorMode = qs.parse(this.props.location.search).errorMode;
    if (errorMode) {
      throw new Error('Sample Error');
    }
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  validateCompanyInput = (company) => {
    const constraints = {
      companyName: {
        presence: { allowEmpty: false }
      },
      industry: {
        presence: { allowEmpty: false }
      },
      legalForm: {
        presence: { allowEmpty: false }
      },
      numberOfEmployees: {
        presence: { allowEmpty: false }
      },
      'executiveBoard.firstName': {
        presence: { allowEmpty: false }
      },
      'executiveBoard.lastName': {
        presence: { allowEmpty: false }
      },
      'dataProtectionOfficer.assigned': {
        presence: { allowEmpty: false }
      },
      'dataProtectionOfficer.firstName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.dataProtectionOfficer.assigned) {
          return { presence: { allowEmpty: false } }
        }
      },
      'dataProtectionOfficer.lastName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.dataProtectionOfficer.assigned) {
          return { presence: { allowEmpty: false } }
        }
      },
      'informationSecurityOfficer.assigned': {
        presence: { allowEmpty: false }
      },
      'informationSecurityOfficer.firstName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.informationSecurityOfficer.assigned) {
          return { presence: { allowEmpty: false } }
        }
      },
      'informationSecurityOfficer.lastName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.informationSecurityOfficer.assigned) {
          return { presence: { allowEmpty: false } }
        }
      },
      'itResponsible.assigned': {
        presence: { allowEmpty: false }
      },
      'itResponsible.firstName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.itResponsible.assigned) {
          return { presence: { allowEmpty: false } }
        }
      },
      'itResponsible.lastName': (value, attributes, attributeName, options, constraints) => {
        if (attributes.itResponsible.assigned) {
          return { presence: { allowEmpty: false } }
        }
      },
    };

    const externalProviderValidationMessages = company.externalITProviders.map(ep => {
      const companyNameField = ep._id + '_companyName';
      let rules = {};
      rules[companyNameField] = {
        presence: { allowEmpty: false }
      };
      ep[companyNameField] = ep.companyName;
      return validate(ep, rules);
    }).reduce((preVal, elem) => {
      return Object.assign(preVal, elem);
    }, {});

    let validationMessages = validate(company, constraints);

    if (!validationMessages)
      validationMessages = externalProviderValidationMessages;
    if (validationMessages && externalProviderValidationMessages)
      validationMessages = Object.assign(validationMessages, externalProviderValidationMessages);

    return validationMessages;
  }

  loadInitialData = (companyId) => {
    getCompanies().then(companies => {
      let selectedCompany = companies.find(c => c._id === companyId);
      if (!selectedCompany && companies.length > 0) {
        selectedCompany = companies[0]; // no companyId specified => select first company
      }
      if (selectedCompany) {
        this.setCompanyState(selectedCompany._id, selectedCompany);
      
        const validationMessages = this.validateCompanyInput(selectedCompany);
        if (!validationMessages || Object.keys(validationMessages).length === 0) {
          this.setState({ hasCompleteCompany: true });
        }
        getAssessmentsByCompanyId(selectedCompany._id).then(assessments => {
          const assessment = assessments[0]; // TODO: support multiple assessments per company
          if (assessment.completed) {
            this.setState({
              hasReport: true
            })
          }
        })
      }
    })
  }

  handleClick = () => {
    this.props.history.push('/company');
  };


  handleClickReportPage = () => {
    getAssessmentsByCompanyId(this.state.company._id).then(assessments => {
      const assessment = assessments[0]; // TODO: support multiple assessments per company
      this.setState({ loading: false });
      this.props.history.push('assessment-report?assessmentId=' + assessment._id)
    })
  }

  handleClickEvaluate = () => {
    let isLevel3 = false;
    getIndustries().then(industries => {
      if (this.state.company.numberOfEmployees.trim() === '250+') {
        isLevel3 = true;
        this.setState({
          message: this.props.i18n._(i18nMark('Security Selfie is designed for SMEs with up to 250 employees. Due to your mentioned company size we recommend a personal consultation and ask you to contact us.'))
        })
      }
      let industryResult = industries.filter(industry => (industry._id === this.state.company.industry && industry.securityLevel === 3));
      if (industryResult.length > 0) {
        isLevel3 = true;
        this.setState({
          message: this.props.i18n._(i18nMark('Security Selfie is suitable for SMEs from various industries. However, due to your mentioned industry, we recommend a personal consultation and ask you to contact us.'))
        })
      }
    }).then(() => {
      getAssessmentsByCompanyId(this.state.company._id).then(assessments => {
        const assessment = assessments[0]; // TODO: support multiple assessments per company
        this.setState({ loading: false, assessmentId: assessment._id });
      }).then(() => {
        if (isLevel3) {
          this.toggle();
          return;
        } else {
          this.navigateQuestion();
        }
      })
    })
  }

  navigateQuestion = () => {
    this.props.history.push('/question?category=organization&assessmentId=' + this.state.assessmentId);
  }

  setCompanyState = (companyId, company) => {
    setCookieCompanyId(this.props.cookies, companyId);
    if (company) {
      this.setState({ company: company });
    }
  }

  render() {
    let reDirectComponent = null;
    let enterCompanyProfileButton = <Button
      text={<Trans id="+ Enter company profile" />}
      onClick={this.handleClick}
      styleButton="button-add-company"
    />
    let startAssessmentButton = <Button
      key={1}
      text={<Trans id="Start Assessment" />}
      onClick={this.handleClickEvaluate}
      styleButton="button-evaluate"
      icon="arrow"
    />;
    let goToReportButton = <Button
      key={1}
      text={<Trans id="Go to Report" />}
      onClick={this.handleClickReportPage}
      styleButton="button-report-page"
    />
    if (this.state.hasCompleteCompany) {
      if (this.state.hasReport) {
        reDirectComponent = [
          startAssessmentButton,
          goToReportButton
        ];
      } else {
        reDirectComponent = startAssessmentButton;
      }
    }
    else {
      reDirectComponent = enterCompanyProfileButton;
    }

    let companyBadge = null;
    if (this.state.company && this.state.company.companyName.length > 0) {
      companyBadge =
        <div className="col-12 dashboard-company text-center">
          <p>
            <span className="badge badge-secondary">{this.state.company.companyName}</span>
          </p>
        </div>
    }

    return (
      <div className="dashboard-container">
        <div className="container">
          <div className="row d-flex flex-column align-items-center">
            <img className="imageStyle" src={imageCenter} alt="" />
            <p className="dashboard-text"><Trans id="Security Selfie" /></p>
            <div className="col-12 col-sm-8 col-lg-7 sub-title text-center">
              <p className="dashboard-subtitle center-align">
                {
                  this.state.hasCompleteCompany ?
                    <Trans id='Now start the assessment by answering the questionnaire. Based on your answers, an automated evaluation is then directly created, recommended measures are derived and presented in a report.' /> :
                    <Trans id='Welcome to the Security Selfie ®! Please provide some details about your company and contacts before the assessment.' />
                }
              </p>
            </div>
            {
              companyBadge
            }
            <div className="col-12 col-sm-8 col-lg-6 col-xl-5 d-flex flex-column flex-md-row justify-content-center align-items-center justify-content-sm-around button-dashboard-container">
              {
                reDirectComponent
              }
            </div>
            <p className="version"><Trans id="Security Selfie v" />{this.state.releaseVersion}</p>
            <ModalDashboad message={this.state.message} className="modal-level" isOpen={this.state.modal} accept={this.navigateQuestion} toggle={this.toggle}></ModalDashboad>
          </div>
        </div>
      </div>
    );
  }
}

export default withI18n()(Dashboard);


// WEBPACK FOOTER //
// ./src/screens/Dashboard/Dashboard.js